import React, { useEffect } from "react"
import { htmlStringToReactElement } from "../../helpers/html"
import { handleMopinion } from "../../helpers/mopinionHelpers"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"

export default function Mopinion({ mopinionId, mopinionScript, backgroundColor, bottomPadding, topPadding }) {
  useEffect(() => {
    handleMopinion(mopinionId)
  }, [])

  const bgColor = SelectionFactoryHelper.getFromSelectionFactory(backgroundColor, false) || undefined
  const tPadding = SelectionFactoryHelper.getFromSelectionFactory(bottomPadding, false) || undefined
  const bPadding = SelectionFactoryHelper.getFromSelectionFactory(topPadding, false) || undefined

  return (
    <div className={`${bgColor} ${tPadding} ${bPadding}`}>
      <div className={`w--wider`}>{mopinionScript ? htmlStringToReactElement(mopinionScript) : ""}</div>
    </div>
  )
}
